import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';
import { throwUnlessApiSuccess } from '../utils/apiResponse';

export const FETCH_AGENTS_REQUEST = 'FETCH_AGENTS_REQUEST';
export const FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS';
export const FETCH_AGENTS_FAILURE = 'FETCH_AGENTS_FAILURE';
export const CREATE_AGENT_SUCCESS = 'CREATE_AGENT_SUCCESS';
export const UPDATE_AGENT_SUCCESS = 'UPDATE_AGENT_SUCCESS';
export const DELETE_AGENT_SUCCESS = 'DELETE_AGENT_SUCCESS';
export const TOGGLE_LOCK_AGENT_SUCCESS = 'TOGGLE_LOCK_AGENT_SUCCESS';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;

export const getAgents = () => async (dispatch) => {
  dispatch({ type: FETCH_AGENTS_REQUEST });
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const response = await axios.post(`${base_url}`, {
      apiName: 'agent',
      command: 'getAgents',
      loggedInUserRole,
      loggedInUsername
    });
    dispatch({ type: FETCH_AGENTS_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({ type: FETCH_AGENTS_FAILURE, payload: error.message || error.response?.data?.message || 'Failed to fetch agents' });
  }
};

export const createAgent = (agentData) => async (dispatch) => {
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const response = await axios.post(`${base_url}`, {
      apiName: 'agent',
      command: 'createAgent',
      loggedInUserRole,
      ...agentData,
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({ type: CREATE_AGENT_SUCCESS, payload: data });
    return response.data;
  } catch (error) { console.error('Failed to create agent:', error); throw error; }
};

export const updateAgent = (agentId, updateData) => async (dispatch) => {
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const response = await axios.post(`${base_url}`, {
      apiName: 'agent',
      command: 'updateAgent',
      agentId,
      updateData,
      loggedInUserRole,
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({ type: UPDATE_AGENT_SUCCESS, payload: data });
    return response.data;
  } catch (error) { console.error('Failed to update agent:', error); throw error; }
};

export const deleteAgent = (agentId) => async (dispatch) => {
  try {
    await axios.post(`${base_url}`, { apiName: 'agent', command: 'deleteAgent', agentId });
    dispatch({ type: DELETE_AGENT_SUCCESS, payload: agentId });
  } catch (error) { console.error('Failed to delete agent:', error); throw error; }
};

export const toggleLockAgent = (agentId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, { apiName: 'agent', command: 'toggleLockAgent', agentId });
    const data = throwUnlessApiSuccess(response);
    dispatch({ type: TOGGLE_LOCK_AGENT_SUCCESS, payload: data });
    return response.data;
  } catch (error) { throw error; }
};
